/* eslint-disable max-len */
import React from 'react';

const CustomCheckbox = ({
    id,
    checked,
    onChange,
    onFocus,
    label,
    disabled,
    classkey
}) => {
    return (
        <div className={`py-[8px] pr-[20px] pl-[8px] flex items-center mark-check mark-check1 ${classkey} relative checkbox custom-checkBoxBlue1`}>
            <input
                type='checkbox'
                id={id}
                onChange={onChange}
                onFocus={onFocus}
                checked={checked}
                className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                disabled={disabled}
            />
            <label htmlFor={id} className='text-xs font-normal text-[#000000] ml-0 cursor-pointer'>
                {label}
            </label>
        </div>
    );
};

export default CustomCheckbox;
